import { App, AutoComplete, Button, Checkbox, Col, Form, Input, InputNumber, List, Row, Select, Tooltip } from 'antd';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import {
  addPmContractProjectWorkPlaceItem,
  updateEquipmentTab,
  updateField,
} from '../../../../../contextRedux/PMContractProject/PmContractModelProject';
import { SearchInput } from '../../../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../../../customComponents/table/CustomTable';
import { RootState } from '../../../../../store';
import { Column } from '../../../../../utils/column';

const { Option } = AutoComplete;

const AddEquipmentTab: React.FC<any> = ({}) => {
  const isMobile = useMediaQuery({ maxWidth: 720 });
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { message } = App.useApp();

  const [searchTerm, setSearchTerm] = useState<string>('');
  const [searchTable, setSearchTable] = useState<string>('');
  const [checkAll, setCheckAll] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const [searchRecomandationPieceNumber, setRecomandationPieceNumber] = useState<number>(1);

  const [checkAllTehnicians, setCheckAllTehnicians] = useState(false);
  const [indeterminateTehnicians, setIndeterminateTehnicians] = useState(false);

  const [stages, setStages] = useState<any>([]);
  const [newStage, setNewStage] = useState<any>('');

  const pmContractProject = useSelector((state: RootState) => state.models.pmContractProject);
  const users = useSelector((state: RootState) => state?.store.user.data);
  const systemTypes = useSelector((state: RootState) => state.store.systemType.data);
  const workPlaces = useSelector((state: RootState) => state.models.pmContractProject.company?.workPlaces);
  const agents = useSelector((state: RootState) => state.models.pmContractProject.company.contactPersons ?? []);
  const selectedSystemTypeId = useSelector(
    (state: RootState) => state.models.pmContractProject.equipmentTab.systemTypeId
  );
  const deviceTypes = useSelector((state: RootState) => state.store.deviceType.data);
  const [filtredDeviceTypes, setFiltredDeviceTypes] = useState<any[]>(
    useSelector((state: RootState) =>
      state.store.deviceType.data.filter(
        (d: any) => d.systemTypeId == state.models.pmContractProject.equipmentTab.systemTypeId
      )
    )
  );

  const addedDevices = pmContractProject.pmContractWorkPlaceItems;

  const handleAddDevice = async (record: any, isFromWorkPlaceItems: boolean = false) => {
    const locations = pmContractProject?.location; // Array of locations in the pmContractProject
    const systemType = form.getFieldValue('systemType');
    const agent = form.getFieldValue('agent');
    let isErrorMessageShown = false;
    let isFilteredErrorMessageShown = false; // New flag for filteredAddedDevice
    let isChiefTechnicianErrorShown = false; // New flag for chief technician validation

    for (const location of locations) {
      // Check if the device is already added for this location
      const isDeviceAlreadyAddedForLocation = addedDevices?.some(
        (ad: any) => ad.deviceTypeId === record.id && ad.workPlaceId === location.id
      );

      if (isDeviceAlreadyAddedForLocation) {
        if (!isErrorMessageShown) {
          message.error(<span>{record?.name} este deja adaugat la această locație!</span>);
          isErrorMessageShown = true; // Prevent further error messages for this device
        }
        continue; // Skip this location if the device is already added
      }

      // Check for filteredAddedDevice condition
      const filteredAddedDevice = addedDevices?.filter(
        (ad: any) =>
          ad.workPlace?.name === location?.name &&
          ad.systemType?.name === systemType?.name &&
          ad.interventionPerSystemType !== pmContractProject.equipmentTab.interventionPerSystemType
      );

      if (filteredAddedDevice?.length > 0) {
        if (!isFilteredErrorMessageShown) {
          message.error(
            <span>
              Nu puteti adauga alt device pe aceeași locație: <b>{filteredAddedDevice[0]?.workPlace?.name}</b>, cu
              același sistem: <b>{filteredAddedDevice[0].systemType?.name}</b> cu o periodicitate diferită de{' '}
              <b>{filteredAddedDevice[0].period}</b> sau un număr de intervenții diferit de{' '}
              <b>{filteredAddedDevice[0].interventionPerSystemType}</b>
            </span>,
            20
          );
          isFilteredErrorMessageShown = true; // Prevent further error messages for filteredAddedDevice
        }
        continue; // Skip this location if the filtered condition is met
      }
      const existingDevicesWithChiefTechnician = addedDevices?.filter(
        (ad: any) =>
          ad.workPlace?.name === location?.name &&
          ad.chiefTehnician &&
          ad.chiefTehnicianId &&
          ad.chiefTehnicianId !== pmContractProject.equipmentTab.chiefTehnicianId
      );

      if (existingDevicesWithChiefTechnician?.length > 0 && pmContractProject.equipmentTab.chiefTehnicianId) {
        if (!isChiefTechnicianErrorShown) {
          message.error(
            <span>
              Nu puteti adauga un device cu tehnician șef diferit pe aceeași locație: <b>{location?.name}</b>. Tehnician
              șef existent: <b>{existingDevicesWithChiefTechnician[0]?.chiefTehnician?.name}</b>
            </span>,
            10
          );
          isChiefTechnicianErrorShown = true;
        }
        continue; // Skip this location if there's already a device with a different chief technician
      }

      if (isFromWorkPlaceItems) {
        const workPlaceItem = location?.workPlaceItems?.find((wpi: any) => wpi?.deviceTypeId === record?.id);
        const pieceCount = workPlaceItem?.piece ?? 1;

        const deviceData = {
          ...record,
          workPlace: location,
          workPlaceId: location?.id,
          device: { ...record },
          deviceTypeId: record.id,
          agent: agent,
          agentId: agent?.id,
          pmContractWorkPlaceItemStage: pmContractProject.equipmentTab.pmContractWorkPlaceItemStage,
          pmContractWorkPlaceItemStageId: pmContractProject.equipmentTab.pmContractWorkPlaceItemStage.id,
          systemType: systemType,
          systemTypeId: systemType?.id,
          pmContractWorkPlaceItemTehnicians: pmContractProject.technician,
          chiefTehnician: pmContractProject.equipmentTab.chiefTehnician,
          chiefTehnicianId: pmContractProject.equipmentTab.chiefTehnicianId,
          metadata: {
            deviceType: { price: record?.price },
          },
          details: pmContractProject.equipmentTab.details,
          unitMeasure: 'buc',
          laborPrice: record?.laborPricePM * pieceCount,
          laborTime: record?.laborTimePM * pieceCount,
          piece: pieceCount,
        };

        dispatch(addPmContractProjectWorkPlaceItem(deviceData));
      } else {
        form.setFieldsValue({
          ...record,
          details: pmContractProject.equipmentTab.details,
          laborTimePMTotal: record?.totalLaborsTimePM,
          laborPricePMTotal: record?.totalLaborsPricePM,
          unitMeasure: 'buc',
          piece: searchRecomandationPieceNumber ?? 1,
        });

        const newItem = {
          id: '',
          offerWorkPlaceId: '',
          workPlace: location,
          workPlaceId: location?.id,
          agent: pmContractProject.equipmentTab.agent,
          agentId: pmContractProject.equipmentTab.agentId,
          systemType: pmContractProject.equipmentTab.systemType,
          systemTypeId: pmContractProject.equipmentTab.systemTypeId,
          chiefTehnician: pmContractProject.equipmentTab.chiefTehnician,
          chiefTehnicianId: pmContractProject.equipmentTab.chiefTehnicianId,
          pmContractWorkPlaceItemStage: pmContractProject.equipmentTab.pmContractWorkPlaceItemStage,
          pmContractWorkPlaceItemStageId: pmContractProject.equipmentTab.pmContractWorkPlaceItemStage.id,
          pmContractWorkPlaceItemTehnicians: pmContractProject.technician,
          device: { ...record },
          deviceTypeId: record.id,
          pmOfferWorkPlaceMetadata: {},
          period: pmContractProject.equipmentTab.period,
          laborPrice: record.laborPricePM,
          laborTime: record.laborTimePM,
          unitMeasure: record.unitMeasure ?? 'buc',
          isAnotherProvider: record.isAnotherProvider ?? false,
          interventionPerSystemType: pmContractProject.equipmentTab.interventionPerSystemType,
          interventionPriceOnRequest: pmContractProject.equipmentTab.interventionPriceOnRequest,
          addition: record.addition,
          piece: searchRecomandationPieceNumber ?? 1,
          metadata: { deviceType: { price: record.price } },
          price: Math.round(
            record.price * (searchRecomandationPieceNumber ?? 1) +
              ((record.price * record.addition) / 100) * (searchRecomandationPieceNumber ?? 1)
          ),
          details: pmContractProject.equipmentTab.details,
        };

        dispatch(addPmContractProjectWorkPlaceItem(newItem));
      }
    }

    if (isErrorMessageShown == false && isFilteredErrorMessageShown == false && isChiefTechnicianErrorShown == false) {
      message.success(
        <span>
          <span className='font-weight-bold'>{record?.name}</span> a fost adăugat.
        </span>
      );
    }
  };

  const handleSelectAgent = (value: string) => {
    const agent = agents.find((awp: any) => awp?.name == value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      agent: agent,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateEquipmentTab({ field: 'agentId', value: agent?.id ?? null }));
    dispatch(updateEquipmentTab({ field: 'agent', value: agent ?? null }));
  };

  const handleSystemType = (value: string) => {
    const systemType = systemTypes.find((st: any) => st.name == value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      systemType: systemType,
      systemTypeId: systemType?.id,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateEquipmentTab({ field: 'systemTypeId', value: systemType?.id ?? null }));
    dispatch(updateEquipmentTab({ field: 'systemType', value: systemType ?? null }));

    setFiltredDeviceTypes(deviceTypes.filter((dt: any) => dt.systemTypeId == systemType.id));
  };

  const handleSelectStage = (value: any) => {
    const pmContractWorkPlaceItemStage = pmContractProject?.equipmentTab?.stages[value];

    if (pmContractWorkPlaceItemStage) {
      const fieldsValue = {
        ...form.getFieldsValue(true),
        pmContractWorkPlaceItemStage: pmContractWorkPlaceItemStage,
        pmContractWorkPlaceItemStageId: pmContractWorkPlaceItemStage?.id,
      };
      form.setFieldsValue(fieldsValue);
      dispatch(
        updateEquipmentTab({ field: 'pmContractWorkPlaceItemStageId', value: pmContractWorkPlaceItemStage?.id ?? null })
      );
      dispatch(
        updateEquipmentTab({ field: 'pmContractWorkPlaceItemStage', value: pmContractWorkPlaceItemStage ?? null })
      );
    } else {
      console.error('Stage not found at the given index.');
    }
  };

  const handleAddStage = () => {
    if (newStage.trim() && !stages.some((s: any) => s.name === newStage)) {
      const newStageObj = { id: '', name: newStage };
      const updatedStages = [...stages, newStageObj];

      setStages(updatedStages);

      // Update Redux store
      dispatch(updateEquipmentTab({ field: 'stages', value: updatedStages }));
      dispatch(updateEquipmentTab({ field: 'pmContractWorkPlaceItemStage', value: newStageObj }));

      setNewStage('');

      const fieldsValue = {
        ...form.getFieldsValue(true),
        pmContractWorkPlaceItemStage: newStageObj,
      };
      form.setFieldsValue(fieldsValue);
    }
  };

  const handleDeleteStage = (stageToDelete: any) => {
    const updatedStages = stages.filter(
      (pmContractWorkPlaceItemStage: any) => pmContractWorkPlaceItemStage.name !== stageToDelete
    );
    setStages(updatedStages);

    // Update Redux store
    dispatch(updateEquipmentTab({ field: 'stages', value: updatedStages }));
  };

  const handleSelectChiefTechnician = (value: string) => {
    const chiefTehnician = users.find((st: any) => st.name == value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      chiefTehnician: chiefTehnician,
      chiefTehnicianId: chiefTehnician?.id,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateEquipmentTab({ field: 'chiefTehnicianId', value: chiefTehnician?.id ?? null }));
    dispatch(updateEquipmentTab({ field: 'chiefTehnician', value: chiefTehnician ?? null }));
  };

  const handleTehnicianChange = (value: any) => {
    // Map selected technicians to include the user property
    const selectedTehnicians = users
      .filter((w: any) => value.includes(w.name))
      .map((user: any) => ({
        id: '',
        pmContractWorkPlaceItemId: '',
        userId: user?.id,
        user: { id: user?.id, name: user?.name }, // Add the user property structure
      }));

    dispatch(updateField({ field: 'technician', value: selectedTehnicians }));
    updateSelectAllTehniciansState(value);
  };

  // Update the handleSelectAllTehniciansChange function
  const handleSelectAllTehniciansChange = (e: any) => {
    const { checked } = e.target;
    const allTehnicians = users.map((user: any) => user.name);

    // Map all technicians to include the user property when selecting all
    const selectedTehnicians = checked
      ? users.map((user: any) => ({
          id: '',
          pmContractWorkPlaceItemId: '',
          userId: user?.id,
          user: { id: user?.id, name: user?.name }, // Add the user property structure
        }))
      : [];

    dispatch(updateField({ field: 'technician', value: selectedTehnicians }));

    form.setFieldsValue({
      tehnician: { name: checked ? allTehnicians : [] },
    });

    setCheckAllTehnicians(checked);
    setIndeterminateTehnicians(false);
  };

  const updateSelectAllTehniciansState = (selected: any) => {
    if (selected.length === users?.length) {
      setCheckAllTehnicians(true);
      setIndeterminateTehnicians(false);
    } else if (selected.length > 0) {
      setCheckAllTehnicians(false);
      setIndeterminateTehnicians(true);
    } else {
      setCheckAllTehnicians(false);
      setIndeterminateTehnicians(false);
    }
  };

  const handleSearchInDeviceTable = (value: string, recomandationPieceNumber: number) => {
    setSearchTable(value);
    setRecomandationPieceNumber(recomandationPieceNumber);
    const filtered = deviceTypes
      ?.filter((device: any) => device.systemTypeId === selectedSystemTypeId)
      .filter(
        (device: any) =>
          (searchRecomandationPieceNumber >= device?.minRecomandation &&
            searchRecomandationPieceNumber <= device?.maxRecomandation &&
            device.name.toLowerCase().includes(value.toLowerCase())) ||
          device.model.toLowerCase().includes(value.toLowerCase()) ||
          device.producer.toLowerCase().includes(value.toLowerCase()) ||
          device.provider.toLowerCase().includes(value.toLowerCase()) ||
          device.price.toString().toLowerCase().includes(value.toLowerCase()) ||
          device.laborTimeSM.toString().toLowerCase().includes(value.toLowerCase()) ||
          device.laborPriceSM.toString().toLowerCase().includes(value.toLowerCase())
      );

    setFiltredDeviceTypes(filtered);
  };

  const handleSearchTermChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleFilter = (inputValue: string, option: any) => {
    return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1;
  };

  const handleLocationChange = (value: any) => {
    const selectedLocations = workPlaces.filter((w: any) => value.includes(w.name));
    dispatch(updateField({ field: 'location', value: selectedLocations }));
    updateSelectAllState(value);
  };

  const handleSelectAllChange = (e: any) => {
    const { checked } = e.target;
    const selectedLocations = checked ? workPlaces : [];
    dispatch(updateField({ field: 'location', value: selectedLocations }));

    form.setFieldsValue({
      location: { name: selectedLocations.map((location: any) => location?.name) },
    });

    setCheckAll(checked);
    setIndeterminate(false);
  };

  const updateSelectAllState = (selected: any) => {
    if (selected.length === workPlaces?.length) {
      setCheckAll(true);
      setIndeterminate(false);
    } else if (selected.length > 0) {
      setCheckAll(false);
      setIndeterminate(true);
    } else {
      setCheckAll(false);
      setIndeterminate(false);
    }
  };

  const deviceTableColumns: Column[] = [
    {
      title: 'Device Id',
      dataIndex: 'id',
      key: 'id',
      hidden: true,
    },
    {
      title: 'System Type Id',
      dataIndex: 'systemTypeId',
      key: 'systemTypeId',
      hidden: true,
    },
    {
      title: 'Imagine',
      dataIndex: 'imageLink',
      key: 'imageLink',
      render: (record: any) =>
        record[0] ? <img src={record[0]} alt='No Image' style={{ width: '100px', height: 'auto' }} /> : 'No image',
      fixed: 'left',
    },
    {
      title: 'Denumire',
      dataIndex: 'name',
      key: 'name',
      render: (text: string) => (
        <Tooltip title={text}>
          <div className='ellipsis-cell'>{text}</div>
        </Tooltip>
      ),
    },
    {
      title: 'System Type',
      dataIndex: ['systemType', 'name'],
      key: 'systemTypeName',
    },
    {
      title: 'Pret',
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: 'Timp Manopera SM (Minute)',
      dataIndex: 'laborTimeSM',
      key: 'laborTimeSM',
    },
    {
      title: 'Pret Manopera SM',
      dataIndex: 'laborPriceSM',
      key: 'laborPriceSM',
    },
    {
      title: 'Producator',
      dataIndex: 'producer',
      key: 'producer',
    },
    {
      title: 'Furnizor',
      dataIndex: 'provider',
      key: 'provider',
    },
    {
      title: 'Model',
      dataIndex: 'model',
      key: 'model',
    },
    {
      title: 'Actiune',
      dataIndex: '',
      key: 'actions',
      fixed: 'right',
      render: (record: any) => {
        // Check if all required properties exist
        const hasLocation = pmContractProject?.location?.length > 0;
        const hasAgent = pmContractProject?.equipmentTab?.agentId != null;
        const hasSystemType = pmContractProject?.equipmentTab?.systemTypeId != null;
        const hasTechnicians = pmContractProject?.technician?.length > 0;
        const hasChiefTechnician = pmContractProject?.equipmentTab?.chiefTehnicianId != null;
        const hasStage = pmContractProject?.equipmentTab?.pmContractWorkPlaceItemStage?.id != null;

        return (
          <Button
            onClick={() => handleAddDevice(record)}
            disabled={!(hasLocation && hasAgent && hasSystemType && hasTechnicians && hasChiefTechnician && hasStage)}
            type='primary'
          >
            Adauga
          </Button>
        );
      },
      width: 10,
    },
  ];

  // Card rendering
  const renderCards = (filtredDeviceTypes: any, handleAddDevice: (device: any) => void, pmContractProject: any) => (
    <div className='cardContainer'>
      {filtredDeviceTypes.map((device: any) => {
        // Check if all required properties exist
        const hasLocation = pmContractProject?.location?.length > 0;
        const hasAgent = pmContractProject?.equipmentTab?.agentId != null;
        const hasSystemType = pmContractProject?.equipmentTab?.systemTypeId != null;
        const hasTechnicians = pmContractProject?.technician?.length > 0;
        const hasChiefTechnician = pmContractProject?.equipmentTab?.chiefTehnicianId != null;
        const hasStage = pmContractProject?.equipmentTab?.pmContractWorkPlaceItemStage?.id != null;

        return (
          <div className='device-card' key={device.id}>
            <img
              src={device.imageLink && device.imageLink[0] ? device.imageLink[0] : ''}
              alt='Device'
              className='cardImage'
            />
            <div className='cardContent'>
              <p>
                <strong>Denumire:</strong> {device.name}
              </p>
              <p>
                <strong>Model:</strong> {device.model}
              </p>
              <p>
                <strong>Pret:</strong> {device.price}
              </p>
            </div>
            <button
              className='addButton'
              onClick={() => handleAddDevice(device)}
              disabled={!(hasLocation && hasAgent && hasSystemType && hasTechnicians && hasChiefTechnician && hasStage)}
            >
              Adauga
            </button>
          </div>
        );
      })}
    </div>
  );
  // Table rendering
  const renderTable = () => (
    <CustomTable initialDataSource={filtredDeviceTypes} columns={deviceTableColumns} rowKey='id' />
  );
  return (
    <>
      <Form form={form} layout='vertical' className='form-container'>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              name={['location', 'name']}
              label='Selectati locatiile'
              rules={[{ required: true, message: 'Alegeti cel putin o locatie!' }]}
            >
              <Select
                mode='multiple'
                allowClear
                placeholder='Selecteaza locatie'
                value={pmContractProject.location?.map((loc: any) => loc?.name)} // Ensure the value is an array of strings
                onChange={handleLocationChange}
                filterOption={handleFilter}
              >
                <Option key='select-all' disabled>
                  <Checkbox indeterminate={indeterminate} onChange={handleSelectAllChange} checked={checkAll}>
                    Select All
                  </Checkbox>
                </Option>
                {workPlaces
                  ?.filter((location: any) => location?.name?.toLowerCase()?.includes(searchTerm.toLowerCase()))
                  .map((location: any, index: any) => (
                    <Option key={index} value={location?.name}>
                      {location?.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              name={['agent', 'name']}
              label='Persoana Contact'
              rules={[{ required: true, message: 'Alegeti o persoana de contact!' }]}
            >
              <AutoComplete
                placeholder='Select an agent'
                onSelect={handleSelectAgent}
                onChange={() => handleSearchTermChange}
                filterOption={handleFilter}
                value={searchTerm}
              >
                {agents?.map((a: any, index: any) => (
                  <Option key={index} value={a?.name}>
                    {a?.name} - {a?.role}
                  </Option>
                ))}
              </AutoComplete>
            </Form.Item>
          </Col>

          {/* {pmContractProject.location.length > 0 && (
            <Col xs={24} sm={12} md={12} lg={8}>
              <Form.Item name='details' label='Detalii situare sistem'>
                <Input placeholder='Ex: Etaj 2, camera A2' onChange={(e) => handleChangeDetails(e.target.value)} />
              </Form.Item>
            </Col>
          )} */}

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              name={['systemType', 'name']}
              label='Tip sistem'
              rules={[{ required: true, message: 'Alegeti un sistem!' }]}
            >
              <AutoComplete
                placeholder='Selectati un sistem'
                onSelect={handleSystemType}
                onChange={() => handleSearchTermChange}
                filterOption={handleFilter}
                value={searchTerm}
              >
                {systemTypes?.map((systemType: any, index: any) => (
                  <Option key={index} value={systemType.name}>
                    {' '}
                    {systemType.name}
                  </Option>
                ))}
              </AutoComplete>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              name={['pmContractWorkPlaceItemStage', 'name']}
              label='Etapa'
              rules={[{ required: true, message: 'Alegeti sau create o etapa!' }]}
            >
              <Select
                placeholder='Selectati sau adaugati o etapa'
                value={pmContractProject?.equipmentTab?.pmContractWorkPlaceItemStage?.name}
                onChange={handleSelectStage}
                style={{ width: '100%' }}
              >
                {stages.map((pmContractWorkPlaceItemStage: any, index: any) => (
                  <Option key={index} value={index}>
                    {pmContractWorkPlaceItemStage.name}
                  </Option>
                ))}
              </Select>
              <div style={{ display: 'flex', marginTop: 8 }}>
                <Input
                  value={newStage}
                  onChange={(e) => setNewStage(e.target.value)}
                  placeholder='Adauga etapa'
                  style={{ flex: 1, marginRight: 8 }}
                />
                <Button type='primary' onClick={handleAddStage} disabled={!newStage.trim()}>
                  Adauga
                </Button>
              </div>
              <List
                size='small'
                bordered
                dataSource={stages}
                renderItem={(
                  pmContractWorkPlaceItemStage: any,
                  index: any // ✅ Use index as key
                ) => (
                  <List.Item
                    actions={[
                      <Button danger size='small' onClick={() => handleDeleteStage(index)}>
                        Sterge
                      </Button>,
                    ]}
                  >
                    {pmContractWorkPlaceItemStage.name}
                  </List.Item>
                )}
                style={{ marginTop: 10 }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              name={['tehnician', 'name']}
              label='Selectati tehnicienii'
              rules={[{ required: true, message: 'Alegeti cel putin un tehnician!' }]}
            >
              <Select
                mode='multiple'
                allowClear
                placeholder='Selectati tehnicienii'
                value={pmContractProject.technician?.map((teh: any) => teh?.user?.name)} // Ensure the value is an array of strings
                onChange={handleTehnicianChange}
                filterOption={handleFilter}
                className='add-equipment-select-input'
              >
                <Option key='select-all' disabled>
                  <Checkbox
                    indeterminate={indeterminateTehnicians}
                    onChange={handleSelectAllTehniciansChange}
                    checked={checkAllTehnicians}
                  >
                    Toate
                  </Checkbox>
                </Option>
                {users.map((user: any, index: any) => (
                  <Option key={index} value={user?.name}>
                    {user?.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              name={['chiefTechnician', 'name']}
              label='Tehnician sef'
              rules={[{ required: true, message: 'Tehnicianul sef este obligatoriu!' }]}
            >
              <AutoComplete
                placeholder='Selectati un tehnician sef'
                onSelect={handleSelectChiefTechnician}
                onChange={() => handleSearchTermChange}
                filterOption={handleFilter}
                value={searchTerm}
              >
                {users?.map((user: any, index: any) => (
                  <Option key={index} value={user.name}>
                    {' '}
                    {user.name}
                  </Option>
                ))}
              </AutoComplete>
            </Form.Item>
          </Col>

          {/* {pmContractProject.location.length > 0 && pmContractProject.equipmentTab.agentId != undefined && (
            <Col xs={24} sm={12} md={12} lg={8}>
              <Form.Item
                name='existentSystem'
                label={`Tipuri de sistem existente pe ${
                  pmContractProject.location.length > 0 ? 'locatiile selectate' : 'locatia selectata'
                }`}
              >
                <AutoComplete placeholder='Select a system' onSelect={handleExistentSystemType}>
                  {Array.from(
                    new Map(
                      pmContractProject.location
                        ?.flatMap((loc: any) => loc.workPlaceItems) // Flatten all workPlaceItems
                        ?.map((item: any) => [
                          item.systemTypeId, // Key by systemTypeId
                          systemTypes.find((st: any) => st.id === item.systemTypeId)?.name, // Map to systemTypeName
                        ])
                    ).values() // Extract unique values
                  )
                    ?.filter(Boolean) // Remove undefined/null
                    ?.map((systemTypeName: any, index: number) => (
                      <Option key={index} value={systemTypeName}>
                        {systemTypeName}
                      </Option>
                    ))}
                </AutoComplete>
              </Form.Item>
            </Col>
          )} */}
        </Row>
        {deviceTypes?.length > 0 ? (
          <div>
            <div className='add-equipment-search-number-line'>
              <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                <Col xs={24} sm={12}>
                  <SearchInput
                    placeholder='Search'
                    value={searchTable}
                    onChange={(e) => handleSearchInDeviceTable(e.target.value, searchRecomandationPieceNumber)}
                    style={{ width: '100%' }}
                    autoFocus={true}
                  />
                </Col>
                <Col xs={24} sm={12}>
                  <InputNumber
                    placeholder='Introduceti numarul de bucati'
                    value={searchRecomandationPieceNumber}
                    min={1}
                    onChange={(value) => handleSearchInDeviceTable(searchTable, value ?? 1)}
                    style={{ width: '100%' }}
                  />
                </Col>
              </Row>
              <div>
                {isMobile ? renderCards(filtredDeviceTypes, handleAddDevice, pmContractProject) : renderTable()}
              </div>
            </div>
          </div>
        ) : null}
      </Form>
    </>
  );
};

export default AddEquipmentTab;
